import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=f3892cfc&scoped=true&"
import script from "./Controls.vue?vue&type=script&lang=js&"
export * from "./Controls.vue?vue&type=script&lang=js&"
import style0 from "./Controls.vue?vue&type=style&index=0&id=f3892cfc&lang=scss&scoped=true&"
import style1 from "./Controls.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3892cfc",
  null
  
)

export default component.exports